/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SendUpdateAppLinkMutationVariables = {
    mobile: string;
    opaqueId?: string | null | undefined;
};
export type SendUpdateAppLinkMutationResponse = {
    readonly sendUpdateAppLink: {
        readonly result: string | null;
    } | null;
};
export type SendUpdateAppLinkMutation = {
    readonly response: SendUpdateAppLinkMutationResponse;
    readonly variables: SendUpdateAppLinkMutationVariables;
};



/*
mutation SendUpdateAppLinkMutation(
  $mobile: String!
  $opaqueId: String
) {
  sendUpdateAppLink(mobile: $mobile, opaqueId: $opaqueId) {
    result
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "mobile"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "opaqueId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "mobile",
        "variableName": "mobile"
      },
      {
        "kind": "Variable",
        "name": "opaqueId",
        "variableName": "opaqueId"
      }
    ],
    "concreteType": "SendUpdateAppLink",
    "kind": "LinkedField",
    "name": "sendUpdateAppLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SendUpdateAppLinkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SendUpdateAppLinkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "98965494d21e65df3ceedee08890dafd",
    "id": null,
    "metadata": {},
    "name": "SendUpdateAppLinkMutation",
    "operationKind": "mutation",
    "text": "mutation SendUpdateAppLinkMutation(\n  $mobile: String!\n  $opaqueId: String\n) {\n  sendUpdateAppLink(mobile: $mobile, opaqueId: $opaqueId) {\n    result\n  }\n}\n"
  }
};
})();
(node as any).hash = '8e3b89df2ecb07f542f8da669441eb47';
export default node;
